import React, { useState,useEffect } from "react";

import axios from '../../axios';
import Slider from "@mui/material/Slider";

export const CustomSlider = (props) => {
    
  const styles = {
  
    color: '#e9eaee',
    
    width: "40rem",
    height: "5px",
    '& .MuiSlider-track': {
      // border: 'none',
      color: '#fed36d',
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: 'orange',
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
          boxShadow: 'inherit',
        },
        '&:before': {
          display: 'none',
        },
      },
      '& .MuiSlider-valueLabel': {
        lineHeight: 1,
        fontSize: 10,
        background: 'unset',
        padding: 0,
        width: 32,
        height: 32,
        borderRadius: '50% 50% 50% 0',
        backgroundColor: '#52af77',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
          transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
        },
        '& > *': {
          transform: 'rotate(45deg)',
        },
      },
  
    '& .MuiSlider-mark': {
      backgroundColor: 'black',
      height: 8,
      width: 0.002,
      '&.MuiSlider-markActive': {
        // opacity: 1,
        backgroundColor: 'black',
      },
    },
    '& .MuiSlider-markLabel': {
      top: 30,
     fontSize: 13,
     color: "#b2b2b2"
    }
    
  }
  const marks = [
    {
      value: 0,
      label: 'Low',
    },
    {
      value: 1,
      label: 'Moderate',
    },
    {
      value: 2,
      label: 'High',
    },
    
  ];
  return(
    <div className="adminSetting">
          <div className="adminSetting__prefix">{props.prefix}</div>
          <div className="adminSetting__main">
            <div className="adminSetting__heading">
              {props.heading}
              
            </div>
            <div className="adminSetting__content">
              <div className="adminSetting__button1"><button onClick={() => props.handleButton(false,true)} >-</button></div>
            

            <div><Slider className="adminSetting__slider"
              
            sx={styles}
            value={props.value}
            onChange={props.handleChange}
              valueLabelDisplay="auto"
              step={1}
              marks={marks}
              min={0}
              max={2}
            /></div>
            <div className="adminSetting__button2"> <button onClick={() => props.handleButton(true,false)}>+</button></div>
           
            </div>
          </div>
        </div>
  )
    
}